import React from 'react';
import { Link } from 'react-router-dom';

const ProductPreview = ({ product, isSmall = false }) => {
  if (!product) return null;
  
  // Get the correct thumbnail URL
  let thumbnailUrl = '';
  
  // Try to get image URL from various properties
  if (product.photos && product.photos.length > 0 && product.photos[0].url) {
    thumbnailUrl = product.photos[0].url;
  } else if (product.picture && product.picture.length > 0 && product.picture[0].url) {
    thumbnailUrl = product.picture[0].url;
  } else if (product.coverImage) {
    thumbnailUrl = product.coverImage.url;
  }
  
  // Small version for inside messages
  if (isSmall) {
    return (
      <Link 
        to={`/product/${product.id}`}
        className="flex items-center p-2 rounded-md bg-white border border-gray-200 hover:bg-gray-50"
      >
        <div className="flex-shrink-0">
          {thumbnailUrl ? (
            <img
              src={thumbnailUrl}
              alt={product.name}
              className="h-10 w-10 object-cover rounded-md"
            />
          ) : (
            <div className="h-10 w-10 bg-gray-200 rounded-md flex items-center justify-center">
              <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          )}
        </div>
        
        <div className="ml-3 min-w-0 flex-1">
          <p className="text-xs font-medium text-gray-900 truncate">
            {product.name}
          </p>
          <p className="text-xs text-gray-500">
            ${product.price}
          </p>
        </div>
      </Link>
    );
  }
  
  // Regular size for context display
  return (
    <Link 
      to={`/product/${product.id}`}
      className="flex items-center p-2 rounded-md hover:bg-gray-50"
    >
      <div className="flex-shrink-0">
        {thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt={product.name}
            className="h-16 w-16 object-cover rounded-md border border-gray-200"
          />
        ) : (
          <div className="h-16 w-16 bg-gray-200 rounded-md flex items-center justify-center border border-gray-200">
            <svg className="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        )}
      </div>
      
      <div className="ml-4 min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-900 truncate">
          {product.name}
        </p>
        <p className="text-sm font-bold text-gray-900 mt-1">
          ${product.price}
        </p>
      </div>
    </Link>
  );
};

export default ProductPreview; 